import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/arrow_left_black.svg'


const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = { class: "v-card-header d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "svg align-text-bottom text-black me-1",
  height: "18",
  width: "18",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "v-card-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "var-cls d-flex" }
const _hoisted_9 = { class: "flex-fill" }
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "prod-list" }
const _hoisted_14 = {
  key: 0,
  class: "no-record"
}
const _hoisted_15 = { class: "flex-fill" }
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick", "title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3-fill" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "col-md-8" }
const _hoisted_23 = { class: "var-cls d-flex" }
const _hoisted_24 = { class: "flex-fill" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["title"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle-fill" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "table" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  colspan: "5",
  class: "no-record"
}
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = ["onClick", "title"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = ["onClick", "title"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3-fill" }, null, -1)
const _hoisted_44 = [
  _hoisted_43
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ProdVariantModal = _resolveComponent("ProdVariantModal")!
  const _component_ProdVariantValueModal = _resolveComponent("ProdVariantValueModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["v-card", {'d-none': _ctx.isStillLoading}])
    }, [
      _createElementVNode("h1", _hoisted_2, [
        _createVNode(_component_RouterLink, { to: "/app/products/products/list" }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.isStillLoading ? `${_ctx.language.loading}...`: _ctx.foundProduct.Name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.language.variants), 1),
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addEditVariantCode(0, null))),
                  title: _ctx.language.add_variant
                }, _hoisted_12, 8, _hoisted_10)
              ])
            ]),
            _createElementVNode("ul", _hoisted_13, [
              (_ctx.lstProdVariants.length == 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, _toDisplayString(_ctx.language.no_variant_fnd), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstProdVariants, (vVar) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: vVar.IdVariant,
                  class: "d-flex"
                }, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(vVar.VariantCode), 1),
                  _createElementVNode("span", null, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => (_ctx.addEditVariantCode(1, vVar)),
                      title: _ctx.language.preview
                    }, _hoisted_18, 8, _hoisted_16),
                    _createTextVNode("  "),
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: ($event: any) => (_ctx.deleteVariantCode(vVar)),
                      class: "text-danger",
                      title: _ctx.language.delete
                    }, _hoisted_21, 8, _hoisted_19)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("h3", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.language.details), 1),
              (_ctx.lstProdVariants.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addEditVariantVal(0, null))),
                      title: _ctx.language.add_variant_det
                    }, _hoisted_28, 8, _hoisted_26)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("table", _hoisted_29, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.language.values), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.language.codes), 1),
                  _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.language.purchase_price), 1),
                  _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.language.sell_price), 1),
                  _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.language.tax_included), 1),
                  _hoisted_33
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.lstProdVariantValues.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                      _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.language.no_variant_fnd), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstProdVariantValues, (vVar) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: vVar.IdVariantDetail
                  }, [
                    _createElementVNode("td", null, _toDisplayString(vVar.VariantValues), 1),
                    _createElementVNode("td", null, _toDisplayString(vVar.VariantCodes), 1),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(vVar.PurchasePrice)), 1),
                    _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(vVar.SellingPrice)), 1),
                    _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.getTaxIncluded(vVar))), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.addEditVariantVal(1, vVar)),
                          title: _ctx.language.preview
                        }, _hoisted_41, 8, _hoisted_39),
                        _createTextVNode("  "),
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.deleteVariantDetail(vVar)),
                          class: "text-danger",
                          title: _ctx.language.delete
                        }, _hoisted_44, 8, _hoisted_42)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_ProdVariantModal, {
        visible: _ctx.isVariantCodeDlgVisible,
        initialValues: _ctx.variantCodeRecord,
        recordStatus: _ctx.variantCodeStatus,
        onCloseForm: _ctx.onCloseProdeCodeDlg
      }, null, 8, ["visible", "initialValues", "recordStatus", "onCloseForm"]),
      _createVNode(_component_ProdVariantValueModal, {
        visible: _ctx.isVariantDetailDlgVisible,
        initialValues: _ctx.variantDetailRecord,
        recordStatus: _ctx.variantDetailStatus,
        lstVariants: _ctx.lstProdVariants,
        basicProduct: _ctx.foundProduct,
        onCloseForm: _ctx.onCloseProdeDetailDlg
      }, null, 8, ["visible", "initialValues", "recordStatus", "lstVariants", "basicProduct", "onCloseForm"])
    ]))
  ], 64))
}